export default __webpack_public_path__ + "static/media/academy-bg-top.c429d11a.jpg";